import { memoize } from "lodash-es";
import { getTenantNamespace } from "./tenant.js";
const getBootFlag = memoize(_getBootFlag);
function _getBootFlag(flag) {
    try {
        const windowValues = parent.chronoBootFlags;
        if (!isJsObject(windowValues)) throw new Error(`Expected a JavaScript object for BootFlags but received '${windowValues}'`);
        if (!(flag.key in windowValues)) throw new Error(`Key '${flag.key}' is missing from BootFlag values`);
        const valueFromWindow = windowValues[flag.key];
        if (!flag.isValid(valueFromWindow)) throw new Error(`Invalid value '${valueFromWindow}' for flag '${flag.key}'`);
        return valueFromWindow;
    } catch (err) {
        const fallbackValue = 'function' == typeof flag.defaultValue ? flag.defaultValue() : flag.defaultValue;
        console.error(`Using default value '${fallbackValue}' for BootFlag '${flag.key}'`, err);
        return fallbackValue;
    }
}
function sentryDefault() {
    const tenantNamespace = getTenantNamespace();
    return tenantNamespace.startsWith('rc-') || 'localhost' === tenantNamespace ? 'disabled' : 'enabled';
}
const BootFlags = {
    FULL_STORY_MODE: stringUnionFlag('fullStoryMode', 'disabled', [
        'enabled',
        'disabled',
        'relayed'
    ]),
    SENTRY_MODE: stringUnionFlag('sentryMode', sentryDefault, [
        'enabled',
        'disabled'
    ]),
    DOORBELL_MODE: stringUnionFlag('doorBellMode', 'disabled', [
        'internal',
        'external',
        'disabled'
    ]),
    NETWORK_MONITORING_ENABLED: stringUnionFlag('networkMonitoringEnabled', 'false', [
        'true',
        'false'
    ]),
    CHAMELEON_MODE: stringUnionFlag('chameleonMode', 'disabled', [
        'enabled',
        'disabled'
    ])
};
function stringUnionFlag(key, defaultValue, validValues) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>{
            for (const valid of validValues)if (windowValue === valid) return true;
            return false;
        }
    };
}
function booleanFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'boolean' == typeof windowValue
    };
}
function numberFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'number' == typeof windowValue
    };
}
function stringFlag(key, defaultValue) {
    return {
        key,
        defaultValue,
        isValid: (windowValue)=>'string' == typeof windowValue
    };
}
function isJsObject(val) {
    return 'object' == typeof val && null !== val && false === Array.isArray(val);
}
function setBootFlag(flag, value) {
    const flags = window.chronoBootFlags ?? {};
    flags[flag.key] = value;
    window.chronoBootFlags = flags;
}
function setBootFlagsToDefaults() {
    if ('production' !== process.env.NODE_ENV) {
        let flagName;
        for(flagName in BootFlags){
            const flag = BootFlags[flagName];
            const value = 'function' == typeof flag.defaultValue ? flag.defaultValue() : flag.defaultValue;
            setBootFlag(flag, value);
        }
    }
}
export { BootFlags, booleanFlag, getBootFlag, numberFlag, setBootFlagsToDefaults, stringFlag, stringUnionFlag };

//# sourceMappingURL=boot-flags.js.map